export const addMessageCard = (thankYouText, thankYouImage, giftCardId) => {
  return {
    type : 'MESSAGE_CARD',
    thankYouText,
    thankYouImage,
    giftCardId
  }
}; 
 